import { useCallback, useEffect, useRef, useState } from 'react';

import EventBusInstance from '@core/eventbus';

export const useEventbus = (callback: (...args: unknown[]) => void, key: string) => {
  if (typeof callback !== 'function') {
    throw new Error('callback must be a function');
  }

  const [isActive, toggleActive] = useState(false);
  const active = useRef(isActive);
  const context = useRef(null);
  const fn = useRef(callback);

  const attach = useCallback(() => {
    if (active.current) return;

    EventBusInstance.on(key, fn.current, context);
    toggleActive(true);
  }, [key]);

  const detach = useCallback(() => {
    if (!active.current) return;

    EventBusInstance.off(key, fn.current, context);
    toggleActive(false);
  }, [key]);

  useEffect(() => {
    fn.current = callback;
  }, [callback]);

  useEffect(() => {
    active.current = isActive;
  }, [isActive]);

  useEffect(() => {
    attach();
    return () => {
      detach();
    };
  }, [attach, detach]);

  return { isActive, attach, detach };
};
